// Constants
import {districtList} from '~/constants/app.constant'
import {
  HOME,
  BLOG_LIST,
  BLOG_DETAILS,
  SALE_PAGE,
  SALE_BY_DISTRICT,
  RENT_PAGE,
  RENT_BY_DISTRICT,
  CONSIGNMENT,
} from '~/constants/pages.constant'

const saleDistrictList = districtList.map(
  (district) => ({
    text: `Bán nhà ${district.name}`,
    to: `/ban-nha-${district.slug}`,
  }),
)

const rentDistrictList = districtList.map(
  (district) => ({
    text: `Thuê nhà ${district.name}`,
    to: `/thue-nha-${district.slug}`,
  }),
)

export default [
  {
    text: 'Trang chủ',
    href: HOME,
    to: HOME,
    activePaths: [HOME],
  },
  {
    text: 'Mua nhà',
    to: '/mua-ban',
    activePaths: [SALE_PAGE, SALE_BY_DISTRICT],
    children: [
      ...saleDistrictList,
      {
        text: 'Bán nhà Các quận khác',
        to: '/ban-nha-cac-quan-khac',
      },
    ],
  },
  {
    text: 'Thuê nhà',
    to: '/thue-nha',
    activePaths: [RENT_PAGE, RENT_BY_DISTRICT],
    children: [
      ...rentDistrictList,
      {
        text: 'Thuê nhà Các quận khác',
        to: '/thue-nha-cac-quan-khac',
      },
    ],
  },
  {
    text: 'Blog đầu tư',
    to: BLOG_LIST,
    activePaths: [
      BLOG_LIST,
      BLOG_DETAILS,
    ],
  },
  {
    text: 'Ký gửi',
    to: '/ky-gui',
    activePaths: [CONSIGNMENT],
  },
]
